// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__1f-ks"};